import { handleActions } from 'redux-actions';

const handleMessage = (state, action) => {
	if (typeof action.payload.message === 'string') {
		return action.payload.message;
	}

	return {
		...state[action.payload.modal].message,
		...action.payload.message,
	};
};

export default handleActions(
	{
		SET_MODAL_BACKGROUND_SCROLLY: (state, action) => ({
			...state,
			globalTop: action.payload,
		}),

		OPEN_MESSAGE_MODAL: (state, action) => ({
			...state,
			[action.payload.modal]: {
				open: true,
				message: handleMessage(state, action),
			},
		}),

		CLOSE_MESSAGE_MODAL: (state, action) => ({
			...state,
			[action.payload.modal]: {
				open: false,
				message: state[action.payload.modal].message === 'string' ? '' : {},
			},
		}),
	},
	{
		filterAddress: {
			open: false,
			message: '',
		},

		filterPrice: {
			open: false,
			message: '',
		},

		filterAdvance: {
			open: false,
			message: '',
		},

		reservationVerifying: {
			open: false,
			message: '',
		},

		reservationInfo: {
			open: false,
			message: '',
		},

		bookingInfo: {
			open: false,
			message: '',
		},

		renewInfo: {
			open: false,
			message: '',
		},

		bookingCheckout: {
			open: false,
			message: '',
		},

		loginSignup: {
			open: false,
			message: {
				type: '',
				success: false,
				alert: '',
			},
		},

		selectSong: {
			open: false,
			message: '',
		},

		globalTop: 0,
	},
);



// WEBPACK FOOTER //
// ./src/reducers/modal.js